import React from 'react';
import { style } from 'glamor';
import { injectIntl, defineMessages } from 'react-intl';

import badgeEnglish from 'depop/assets/stores/google-play-en.svg';
import badgeItalian from 'depop/assets/stores/google-play-it.svg';

const getBadge = (language) => {
  switch (language) {
    case 'it':
      return badgeItalian;
    case 'en':
    default:
      return badgeEnglish;
  }
};

const messages = defineMessages({
  lang: {
    id: 'Language.ShortCode',
    defaultMessage: 'en'
  },
  alt: {
    id: 'PlayStore.alt',
    defaultMessage: 'Get it on the Play Store'
  }
});

const badgeStyle = style({
  width: 145,
  height: 48,
  display: 'block',
  verticalAlign: 'bottom'
});

class PlayStore extends React.Component {
  props: {
    intl: Object,
  }

  render () {
    const { intl } = this.props;

    return <img {...badgeStyle} alt={intl.formatMessage(messages.alt)} src={getBadge(intl.formatMessage(messages.lang))} />;
  }
};

// export default () => (
//   <img {...badgeStyle} src={badgeEnglish} />
// );

export default injectIntl(PlayStore);



// WEBPACK FOOTER //
// ../src/client/components/badges/PlayStore.js